import { SyncManager } from 'db';
import { useField } from 'react-final-form';
import { useFormVehicleId } from './useFormVehicleId';
import { base64ToObjectUrl } from 'utils';

export type SaveImageFn = (payload: {
  file?: File | string | null;
  url?: string;
  url_thumb?: string;
  expiration_date?: string;
  is_damaged?: boolean;
  grade?: number;
  notes?: string;
}) => Promise<void>;

export const useUpdateImage = (sectionId: string, i: number): SaveImageFn => {
  const {
    input: { value: serverId }
  } = useField(`${sectionId}.id`);

  const {
    input: { value: imageId, onChange: updateId }
  } = useField(`${sectionId}.images.${i}.id`);

  const {
    input: { value: type }
  } = useField(`${sectionId}.images.${i}.type`);

  // const { input: urlInput } = useField(`${sectionId}.images.${i}.url`);
  const { input: localUrlInput } = useField(`${sectionId}.images.${i}.local_url`);

  const [, parsedType] = type?.split('.') || [];
  const { input: sectionGradeInput } = useField(`${sectionId}.subsections.${parsedType}.grade`);

  const vehicleId = useFormVehicleId();

  const save: SaveImageFn = async payload => {
    if (!vehicleId || Object.keys(payload).length === 0) return;
    const syncManager = SyncManager.getInstance(vehicleId);

    const isNewImage = !imageId || imageId.toString() === `${serverId}-${i}`;
    const entityType = isNewImage ? 'new_image' : 'image';
    const entityId = entityType === 'new_image' ? `${serverId}-${i}` : imageId;

    await syncManager.queueEntityUpdate(entityId, entityType, Object.entries(payload));

    if (entityType === 'new_image' && !imageId) {
      updateId(entityId);
    }

    if (payload.file && typeof payload.file === 'string') {
      localUrlInput.onChange(base64ToObjectUrl(payload.file));
    }

    // todo: maybe queue this updates separately to not have double logic on fe and server
    // or return them from the server after sync
    const isTiresSection = sectionId.includes('tires');
    if (isTiresSection && payload.grade != null) {
      if (payload.grade <= 2) {
        sectionGradeInput.onChange('poor');
      } else if (payload.grade === 3) {
        sectionGradeInput.onChange('fair');
      } else {
        sectionGradeInput.onChange('good');
      }
    }
  };

  return save;
};
